export const SFWTranslations = {
  de: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Montageboxen",
    walkThrough: "Rundgang",
    createOrder: "Auftrag starten",
    noWorkOrderStarted: "Kein gestarteter Auftrag",
    mechanik: "Mechanik",
    elektrik: "Elektrik",
    general: "Allgemein",
    editTicketData: "Daten bearbeiten",
    finishWorkOrder: "Auftrag Abschließen",
    workOrderStarted: "Auftrag gestartet",
    createOrderDialogTitle: "Auftrag starten",

    finishWorkOrderConfirmTitle: "Auftrag abschließen",
    finishWorkOrderConfirmMessage:
      "Möchten Sie den Auftrag wirklich abschließen?",
    workOrderFinished: "Auftrag abgeschlossen",
    switchToOrderDetailView: "Zur Auftragsansicht wechseln",
    walkThroughView: "Rundgang",
    more: "Mehr",
    noAssets: "Keine Anlagen gefunden",
    reorderAssets: "Anlagenreihenfolge ändern",
    sfwOrderHistory: "Aufträge",
    sfwWalkthroughStatus: "Rundgangsstatus",
    sfwWalkthroughStatusDescription: "Status des Rundgangs",
    activeOrders:
      "kein aktiver Auftrag | ein aktiver Auftrag | {count} aktive Aufträge",
    templateNotFound: "Schablone nicht gefunden",
    transferToNextStation: "Transferieren",
    transferDialogTitle: "Auftrag transferieren",
    targetStation: "Zielstation",
    transferNote: "Notiz (optional)",
    transfer: "Transferieren",
    transferSuccess: "Auftrag transferiert an {name}",
    switchToEntity: "Zur {name} wechseln",
    sfwTicketHistory: "Ticket-Historie",
    assignedAt: "Zugewiesen am",
    unassignedAt: "Abgewiesen am",
    sfwCurrentlyActive: "Aktuell aktiv",
    processingHistory: "Verarbeitungshistorie",
    reopenWorkOrder: "Auftrag wiedereröffnen",
    reopenWorkOrderConfirmTitle: "Auftrag wiedereröffnen",
    reopenComment: "Kommentar (optional)",
    workOrderReopened: "Auftrag wiedereröffnet",
    history: "Historie",
    createTicket: "Ticket erstellen",
    ticketType: "Tickettyp",
    sfwTicketSearch: "Ticketsuche",
  },
  en: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Assembly Boxes",
    walkThrough: "Walk-through",
    createOrder: "Start work order",
    noWorkOrderStarted: "No work order started",
    mechanik: "Mechanics",
    elektrik: "Electrics",
    general: "General",
    editTicketData: "Edit data",
    workOrderStarted: "Work order started",
    createOrderDialogTitle: "Start Work Order",
    finishWorkOrder: "Finish Work Order",
    finishWorkOrderConfirmTitle: "Finish work order",
    finishWorkOrderConfirmMessage:
      "Are you sure you want to finish this work order?",
    workOrderFinished: "Work order finished",
    switchToOrderDetailView: "Switch to order detail view",
    walkThroughView: "Walk-through",
    more: "More",
    noAssets: "No assets found",
    reorderAssets: "Change asset order",
    sfwWalkthroughStatus: "Walk-through Status",
    sfwWalkthroughStatusDescription: "Walk-through status",
    sfwOrderHistory: "Orders",
    activeOrders: "no active orders | one active order | {count} active orders",
    templateNotFound: "Template not found",
    transferToNextStation: "Transfer",
    transferDialogTitle: "Transfer work order",
    targetStation: "Target station",
    transferNote: "Note (optional)",
    transfer: "Transfer",
    transferSuccess: "Work order transferred to {name}",
    switchToEntity: "Switch to {name}",
    sfwTicketHistory: "Ticket History",
    assignedAt: "Assigned",
    unassignedAt: "Unassigned",
    sfwCurrentlyActive: "Currently active",
    processingHistory: "Processing History",
    reopenWorkOrder: "Reopen Work Order",
    reopenWorkOrderConfirmTitle: "Reopen work order",
    reopenComment: "Comment (optional)",
    workOrderReopened: "Work order reopened",
    history: "History",
    createTicket: "Create Ticket",
    ticketType: "Ticket type",
    sfwTicketSearch: "Ticket Search",
  },
  es: {
    shopFloorWalk: "Recorrido de planta",
    sfwAssets: "Cajas de montaje",
    walkThrough: "Recorrido",
    createOrder: "Iniciar orden de trabajo",
    noWorkOrderStarted: "No se ha iniciado ninguna orden de trabajo",
    mechanik: "Mecánica",
    elektrik: "Electricidad",
    general: "General",
    editTicketData: "Editar datos",
    workOrderStarted: "Orden de trabajo iniciada",
    createOrderDialogTitle: "Iniciar orden de trabajo",
    finishWorkOrder: "Finalizar orden de trabajo",
    finishWorkOrderConfirmTitle: "Finalizar orden de trabajo",
    finishWorkOrderConfirmMessage:
      "¿Está seguro de que desea finalizar esta orden de trabajo?",
    workOrderFinished: "Orden de trabajo finalizada",
    switchToOrderDetailView: "Cambiar a vista de detalles de la orden",
    walkThroughView: "Recorrido",
    more: "Más",
    noAssets: "No se encontraron activos",
    reorderAssets: "Cambiar orden de los activos",
    sfwWalkthroughStatus: "Estado del recorrido",
    sfwWalkthroughStatusDescription: "Estado del recorrido",
    sfwOrderHistory: "Órdenes",
    activeOrders:
      "ninguna orden activa | una orden activa | {count} órdenes activas",
    templateNotFound: "Plantilla no encontrada",
    transferToNextStation: "Transferir",
    transferDialogTitle: "Transferir orden de trabajo",
    targetStation: "Estación de destino",
    transferNote: "Nota (opcional)",
    transfer: "Transferir",
    transferSuccess: "Orden de trabajo transferida a {name}",
    switchToEntity: "Cambiar a {name}",
    sfwTicketHistory: "Historial de tickets",
    assignedAt: "Asignado",
    unassignedAt: "Desasignado",
    sfwCurrentlyActive: "Actualmente activo",
    processingHistory: "Historial de procesamiento",
    reopenWorkOrder: "Reabrir orden de trabajo",
    reopenWorkOrderConfirmTitle: "Reabrir orden de trabajo",
    reopenComment: "Comentario (opcional)",
    workOrderReopened: "Orden de trabajo reabierta",
    history: "Historial",
    createTicket: "Crear ticket",
    ticketType: "Tipo de ticket",
    sfwTicketSearch: "Búsqueda de tickets",
  },
};
